//CSS
import './MGModalityCardDetail.css'
import { ArrowRight } from 'lucide-react';


export default function MGModalityCardDetail({ title, subscriptionsNumber, leftTitle, leftAmount, rightTitle, rightAmount, rightColor = "#222324"
}) {

    const amountsContainer = () => {
        return (
            <div className="MGModalityCardDetail-amount-container">
                <session className="MGModalityCardDetail-amount" >
                    <h6>{leftTitle}</h6>
                    <h5 style={{ color: "#222324" }}>{new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(leftAmount)}</h5>
                </session>
                <hr className="MGModalityCardDetail-separator" />
                <session className="MGModalityCardDetail-amount" >
                    <h6>{rightTitle}</h6>
                    <h5 style={{ color: rightColor }}>+ {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(rightAmount)}</h5>
                </session>
            </div>
        );
    }

    return (
        <div className='MGModalityCardDetail-card'>
            <div className='MGModalityCardDetail-title'>
                <div>
                    <h6>{title}</h6>
                    <ArrowRight height={'24px'} width={'24px'} />
                </div>
                <p>{subscriptionsNumber === 1 ? subscriptionsNumber + " subscrição" : subscriptionsNumber + " subscrições"}</p>

            </div>
            <div>
                {amountsContainer()}
            </div>
        </div>
    );
}